import { useState, useMemo } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const asSrc = (im) => {
  // tolerate multiple shapes: string, {base64}, {url}, {src}
  if (!im) return "";
  if (typeof im === "string") return im;                // already a data: url
  return im.base64 || im.url || im.src || "";
};

const ImageGallery = ({ message }) => {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const galleryImages = useMemo(() => {
    const imgs = Array.isArray(message?.images) ? message.images : [];
    return imgs
      .map((im, i) => {
        const src = asSrc(im);
        return src
          ? {
              src,                // prefer data: if available
              thumbnail: src,
              isSelected: false,
              caption: `Image ${i + 1}`,
            }
          : null;
      })
      .filter(Boolean);
  }, [message?.images]);

  if (galleryImages.length === 0) return null;

  // Treat missing/boolean/string values uniformly
  const galleryFlag = message?.gallery;
  const isGallery =
    galleryFlag === true ||
    galleryFlag === "true" ||
    (galleryFlag == null && galleryImages.length > 1);

  const isSingle =
    galleryFlag === false ||
    galleryFlag === "false" ||
    (galleryFlag == null && galleryImages.length === 1);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setIsGalleryOpen(true);
  };

  // chunk helper
  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  return (
    <div className="media-container" data-gallery="react">
      {/* Single image */}
      {isSingle && (
        <div className="single-image-container" onClick={() => openLightbox(0)}>
          <img src={galleryImages[0].src} alt="Media" className="single-image" />
        </div>
      )}

      {/* Grid gallery (3 per row on your CSS) */}
      {isGallery && (
        <div className="custom-gallery-container">
          {chunk(galleryImages, 3).map((row, rIdx) => (
            <div key={rIdx} className={`gallery-row col-${row.length}`}>
              {row.map((it, cIdx) => {
                const idx = rIdx * 3 + cIdx;
                return (
                  <div
                    key={idx}
                    className={`gallery-item item-${idx}`}
                    onClick={() => openLightbox(idx)}
                  >
                    <img src={it.src} alt="Media" className="single-image" />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}

      {isGalleryOpen && lightboxIndex != null && (
        <Lightbox
          mainSrc={galleryImages[lightboxIndex]?.src}
          nextSrc={galleryImages[(lightboxIndex + 1) % galleryImages.length]?.src}
          prevSrc={
            galleryImages[
              (lightboxIndex + galleryImages.length - 1) % galleryImages.length
            ]?.src
          }
          onCloseRequest={() => setIsGalleryOpen(false)}
          onMovePrevRequest={() =>
            setLightboxIndex(
              (lightboxIndex + galleryImages.length - 1) % galleryImages.length
            )
          }
          onMoveNextRequest={() =>
            setLightboxIndex((lightboxIndex + 1) % galleryImages.length)
          }
        />
      )}
    </div>
  );
};

export default ImageGallery;